<!-- Loader.vue -->
<template>
  <div v-if="loading" class="loader-wrapper">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}
/* HTML:  */
.loader {
  width: 36px;
  aspect-ratio: 1;
  color: #25b09b;
  background: linear-gradient(45deg,#0000 24%,currentColor 0 76%,#0000 0);
  position: relative;
  animation: l23-0 1.5s infinite;
}
.loader:before,
.loader:after {
  content: "";
  position: absolute;
  width: 50%;
  height: 50%;
  background: currentColor;
  transform-origin: top left;
  clip-path: polygon(-2px 0,0 -1px,100% 100%,-2px 100%);
  inset: auto auto 0 0;
  animation: l23-1 1.5s infinite;
}
.loader:after {
  inset:0 0 auto auto;
  transform-origin: bottom right;
  clip-path: polygon(0 0,calc(100% + 2px) 0,calc(100% + 2px) 100%,100% calc(100% + 1px));
}
@keyframes l23-0 {
  0% ,50%   {transform:skewX(0)}
  90%,100%  {transform:skewX(-45deg)}
}
@keyframes l23-1 {
  40%,100%  {transform:rotate(180deg);box-shadow: 0 0 0 3px;}
}
</style>
